import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useError } from '../../contexts/ErrorContext';
import ActionDialog from './ActionDialog';

const ErrorDialog = () => {
  const { error, clearError } = useError();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (error) {
      setIsOpen(true);
    }
  }, [error]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleExited = () => {
    clearError();
  };

  return (
    <ActionDialog
      open={isOpen}
      onClose={handleClose}
      onConfirm={handleClose}
      showCancel={false}
      TransitionProps={{ onExited: handleExited }}
    >
      <Typography sx={{ textAlign: 'center', whiteSpace: 'pre-line', lineHeight: 1.5 }}>{error?.message}</Typography>
    </ActionDialog>
  );
};

export default ErrorDialog;
